import React from "react";
import { ImageBackground } from "react-native";

import { styles } from "./styles";

export const Background = ({ image, style, children }) => (
  <ImageBackground
    source={{ uri: image || null }}
    style={[styles.background, style]}
  >
    {children}
  </ImageBackground>
);

export default Background;
